import type { ButtonProps } from '@sravni/react-design-system/lib/Button';

import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { TPreapprovalOfferStep } from 'shared/types/TRankingService';

import { GoToRefMplPreApprovalOffer } from '../GoToRefOffer';
import { MplOfferMoreInfo } from '../MoreInfo';
import { Pending } from '../Pending';
import { SendOffer } from '../SendOffer';

import { getOfferIsReferral } from './preApprovalOfferAdapters';
import { StartStepFlowButton } from './StartStepFlowButton';

type Props = {
  offer: MPLPreApprovalOffer;
  goNext: () => void;
  currentStep?: TPreapprovalOfferStep;
  isStepFlowActive: boolean;
  startStepFlow: () => void;
  isApplicationSending?: boolean;
  buttonProps?: ButtonProps;
};

export const MplOfferStepControls: FC<Props> = (props: Props) => {
  const { offer, currentStep, goNext, isStepFlowActive, startStepFlow, isApplicationSending, buttonProps } = props;
  const { apiStatus, isAlreadySentFromSameBank } = offer;
  const isReferral = getOfferIsReferral(offer);
  const isSendingApplicationDisabled = !isReferral && (apiStatus || isAlreadySentFromSameBank);
  const isShowMoreInfoButton = isSendingApplicationDisabled && (currentStep === 'application' || !isStepFlowActive);

  if (offer.status === 'pending') {
    return <Pending {...buttonProps}>Ждём ответ</Pending>;
  }

  if (isShowMoreInfoButton) {
    return (
      <MplOfferMoreInfo
        offer={offer}
        buttonProps={buttonProps}
      />
    );
  }

  if (!currentStep) {
    if (isReferral) {
      return (
        <GoToRefMplPreApprovalOffer
          offer={offer}
          buttonProps={buttonProps}
        />
      );
    }
    return (
      <SendOffer
        offer={offer}
        buttonProps={{
          ...buttonProps,
          onClick: (e) => {
            goNext();
            buttonProps?.onClick?.(e);
          },
        }}
      />
    );
  }

  if (!isStepFlowActive) {
    return (
      <StartStepFlowButton
        offer={offer}
        buttonProps={{
          ...buttonProps,
          onClick: (e) => {
            startStepFlow();
            buttonProps?.onClick?.(e);
          },
        }}
      />
    );
  }

  switch (currentStep) {
    case 'iframe':
    case 'delivery':
    case 'confirmation':
      return <Pending {...buttonProps} />;
    case 'application': {
      if (isReferral) {
        return (
          <GoToRefMplPreApprovalOffer
            offer={offer}
            buttonProps={buttonProps}
          />
        );
      }
      return (
        <SendOffer
          offer={offer}
          buttonProps={{
            ...buttonProps,
            loading: isApplicationSending || buttonProps?.loading,
            onClick: (e) => {
              goNext();
              buttonProps?.onClick?.(e);
            },
          }}
        />
      );
    }
    default:
      return null;
  }
};
